import { Amplify } from "aws-amplify";
import { getConfig } from "./Config";

export function configureAmplify(): void {
  const config = getConfig();

  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: config.COGNITO_USER_POOL_ID,
        userPoolClientId: config.COGNITO_CLIENT_ID,
        loginWith: {
          email: true,
          username: true
        },
        signUpVerificationMethod: "code",
        mfa: {
          status: "optional",
          smsEnabled: true,
          totpEnabled: true
        }
      }
    }
  });
}
